(function () {
'use strict';

var documentInit;

(function($){
		
	documentInit = function(){
		new Document();
	};
	
	class Document {
		constructor(){
			this.init();
			this.bind();
		}
		
		init() {
			this.$body = $(document.body);
			
			document.headerHeightScrolled = 100;
		}
		
		bind(){
			$(window).scroll( (e) => { this.scroll(); });
		}
		
		scroll(){
			
			var scroll = window.scrollY;
			
			if( scroll > 0 && ! this.$body.hasClass('is-scrolled')  ){
				this.$body.addClass('is-scrolled');
				return;
			}
			
			if( scroll == 0 && this.$body.hasClass('is-scrolled')  ){
				this.$body.removeClass('is-scrolled');
				return;
			}
				
		}
		
	}

})(jQuery);
	
var documentInit$1 = documentInit;

var scrollNavInit;

(function($){
		
	const selectors = {
		navContainer: '[data-scroll-nav]',
	};
	
	scrollNavInit = function(){
		$(selectors.navContainer).each((i, el) => {
			new ScrollNav(el);
		});
	};
	
	class ScrollNav {
		constructor(element){
			this.nav = element;
			
			this.init();
			this.resize();
			this.bind();
			
			this.scroll();
			// this.checkBreakpoint();
			
			
		}
		init(){
			
			this.links = $('a[href^="#"]:not([href="#"])', this.nav);
			this.targets = [];
			this.links.each((i, link) => {
				var $target = $( $(link).attr('href') );
				if($target.length){
					var targetData = {
						el: $target.get(0),
						link: link,
						offset: $target.offset().top
					};
					
					if( $(targetData.link).attr('data-offset') !== undefined ){ 
						targetData.offset -= parseFloat( $(targetData.link).attr('data-offset') );
					}
					else if( document.headerHeightScrolled && $(targetData.link).attr('data-ignore-header') === undefined ){ 
						targetData.offset -= document.headerHeightScrolled;
					}
					
					this.targets.push(targetData);
				}
			});
			
			// console.log(this);
		}
		resize(){
			$(this.targets).each((i, targetData) => {
				
				targetData.offset = $(targetData.el).offset().top;
				
				if( $(targetData.link).attr('data-offset') !== undefined ){ 
					targetData.offset -= parseFloat( $(targetData.link).attr('data-offset') );
				}
				else if( document.headerHeightScrolled && $(targetData.link).attr('data-ignore-header') === undefined ){ 
					targetData.offset -= document.headerHeightScrolled;
				}
			});
			
			this.targets.sort((a,b) => (a.offset > b.offset) ? 1 : ((b.offset > a.offset) ? -1 : 0)); 

		}
		bind(){
			
			$(document).ready((e)=>{ this.resize(); });
			$(window).resize( (e) => { this.resize(); });
			
			$(window).scroll( (e) => { this.scroll(); });
			
			$(window).on('smooth-scroll-started', (e) => { this.isScrolling = true; });
			$(window).on('smooth-scroll-ended', (e) => { this.isScrolling = false; });
			
			// $(window).on('changed.zf.mediaquery', (e) => { this.checkBreakpoint(); });
			
			$(this.links).click( (e) => { this.linkClicked( $(e.target).closest('a').get(0) ); });
		}
		
		scroll(){
			
			if( this.isScrolling ) return;
			
			const _this = this;
			var scrollOff = $(window).scrollTop();
			
			// console.log("#######");
			
			$(_this.targets).each((i, targetData) => {
				
				var is_active = scrollOff >= targetData.offset;
				
				// console.log(scrollOff, targetData, is_active);
				
				if( i == 0 && scrollOff < targetData.offset ) {
					is_active = true;
				}
				
				if( i < _this.targets.length -1 && scrollOff >= _this.targets[i+1].offset ) {
					// console.log('next active');
					is_active = false;
				}
				
				if( is_active ){
					$(targetData.link).addClass('is-active');
				}
				else {
					$(targetData.link).removeClass('is-active');
				}
				
			});
				
		}
		
		// checkBreakpoint(){
		// 	
		// 	if( Foundation.MediaQuery.atLeast('medium') ){
		// 		this.fixto.start();
		// 	}
		// 	else {
		// 		this.fixto.stop();
		// 	}
		// }
		
		linkClicked(link){
			
			if( ! $( $(link).attr('href') ).length ) return;
			
			$(this.links).removeClass('is-active');
			$(link).addClass('is-active');
			$(link).blur();
		}
		
	}

})(jQuery);
	
	
var scrollNavInit$1 = scrollNavInit;

var smoothScrollInit;

(function($){
		
	const selectors = {
		link: 'a[href^="#"]:not([href="#"]):not([data-ignore-scroll])',
	};
	
	smoothScrollInit = function(){
		$(selectors.link).each((i, el) => {
			new Link(el);
		});
	};
	
	class Link {
		constructor(element){
			this.$link = $(element);
			
			this.init();
			this.bind();
			
		}
		init(){
			this.$target = $( this.$link.attr('href') );
			this.animationTime = 700;
		}
		bind(){
			this.$link.click( (e) => { e.preventDefault(); this.linkClicked(); });
		}
		
		
		
		linkClicked(){
			if( ! this.$target.length ) return;
			
			var offTop = this.$target.offset().top;
			
			if( document.headerHeightScrolled && this.$link.attr('data-ignore-header') === undefined ){ 
				offTop -= document.headerHeightScrolled;
			}
			
			$(window).trigger('smooth-scroll-started');
			
			$('html, body').stop().animate( {scrollTop: offTop}, this.animationTime, function(){
				$(window).trigger('smooth-scroll-ended');
			} );
			
		}
		
	}
})(jQuery);
	
	
var smoothScrollInit$1 = smoothScrollInit;

var modalInit;

(function($){
		
	const selectors = {
		modal: '[data-modal]',
		close: '[data-modal-close]'
	};
	
	modalInit = function(){
		$(selectors.modal).each((i, el) => {
			new Modal(el);
		});
	};
	
	class Modal {
		constructor(element){
			this.$modal = $(element);
			
			this.init();
			this.bind();
			
			
		}
		init(){
			this.$triggers = $('a[href="#'+this.$modal.attr('id')+'"]');
			this.$close_btns = $(selectors.close, this.$modal);
		}
		bind(){
			this.$modal.click( (e) => { e.preventDefault(); this.hide(); });
			this.$modal.find('.o-modal__inner').click( (e) => { e.stopPropagation(); });
			this.$triggers.click( (e) => { e.preventDefault(); this.show(); });
			this.$close_btns.click( (e) => { e.preventDefault(); this.hide(); });
		}
		
		
		
		show(){
			this.$modal.stop().fadeIn();
			$(document.body).addClass('is-modal-open');
		}
		hide(){
			this.$modal.stop().fadeOut();
			$(document.body).removeClass('is-modal-open');
		}
		
	}
})(jQuery);
	
var modalInit$1 = modalInit;

var submissionForminit;

(function ($) {

	const selectors = {
		form: '[data-submission-form]',
		reason_select: '[data-reason-select]',
		reason_custom: '[data-reason-custom]'
	};

	submissionForminit = function () {
		$(selectors.form).each((i, el) => {
			new Form(el);
		});
	};

	class Form {
		constructor(element) {
			this.$form = $(element);

			this.init();
			this.bind();

			$(this.reason_select).trigger('change');

		}
		init() {
			this.$buttons = $('[type="submit"]', this.$form);

			this.required_fields = ['name', 'email', 'over16', 'rodo'];
			this.reason_select = $(selectors.reason_select, this.$form).get(0);

		}

		bind() {
			$(this.reason_select).change(() => { this.onReasonSelectChange(); });
			$('[type="submit"]', this.$form).on('click', () => { this.validate(); });
			this.$form.on('submit', (e) => { e.preventDefault(); this.submit(); });
		}

		validate() {
			var valid = true;

			var values = this.$form.serializeArray();
			var formatted_values = {};

			$.each(values, function (i, val) {
				formatted_values[val.name] = val.value;
			});

			$('.is-invalid', this.$form).removeClass('is-invalid');

			$.each(this.required_fields, function (i, field_name) {
				if (!formatted_values[field_name] || !formatted_values[field_name].length) {
					valid = false;
					$('[name="' + field_name + '"]', this.$form).addClass('is-invalid');
				}
			});

			return valid;

		}

		submit() {

			if (this.$buttons.hasClass('is-loading')) return;
			if (!this.validate()) return false;

			var self = this;

			$('[data-form-status]', this.$form).text('').hide().attr('class', 'c-petycja-box__form-status');

			this.$buttons.addClass('is-loading');

			var values = this.$form.serializeArray();
			var formatted_values = {};
			$.each(values, function (i, val) {
				formatted_values[val.name] = val.value;
			});


			$.ajax({
				type: "POST",
				url: 'submission.php',
				dataType: 'json', // data type
				data: formatted_values, // serializes the form's elements.
				success: function (response) {

					self.$buttons.removeClass('is-loading');

					if (response.status) {
						if (response.status == "success") {
							$('[data-form-status]', this.$form).addClass('status-' + response.status);
							self.clear();
							window.location.href = '/dziekujemy';
						}
					}

					// console.log(response); 
					if (response.message) {
						$('[data-form-status]', this.$form).text(response.message).show();
					}


				}
			});


		}

		clear() {
			$('[type="text"],[type="email"], textarea', self.$form).val('');
			$('[type="checkbox"]', self.$form).prop('checked', false);
			$('select option[value=""]').prop('selected', true).trigger('change');
		}

		onReasonSelectChange() {

			var $selected_option = $(this.reason_select[this.reason_select.selectedIndex]);

			if ($selected_option.attr('data-custom') !== undefined) {
				$(selectors.reason_custom, this.$form).stop().slideDown().find('textarea').focus();
			}
			else {
				$(selectors.reason_custom, this.$form).stop().slideUp().find('textarea').blur();
			}

		}

	}
})(jQuery);

var submissionForminit$1 = submissionForminit;

var mobileNavInit;

(function($){
		
	const selectors = {
		navContainer: '[data-mobile-menu]',
		trigger: '[data-mobile-menu-trigger]',
	};
	
	mobileNavInit = function(){
		$(selectors.navContainer).each((i, el) => {
			new MobileNav(el);
		});
	};
	
	class MobileNav {
		constructor(element){
			this.$container = $(element);
			
			this.init();
			this.bind();
			// console.log(this);
			
		}
		init(){	
			this.$trigger = $(selectors.trigger, this.$container);
			this.$links = $('a', this.$container).not( this.$trigger );
		}
		
		bind(){
			this.$trigger.click( (e) => { this.toggle(); });
			this.$links.click( (e) => { this.hide(); });
		}
		
		toggle(){
			if( this.$container.hasClass('is-active') ){
				this.hide();
			}
			else {
				this.show();
			}
		}
		
		show(){
			this.$container.addClass('is-active');
		}
		
		hide(){
			this.$container.removeClass('is-active');
		}
		
	}

})(jQuery);
	
	
var mobileNavInit$1 = mobileNavInit;

var slickInit;

(function($){
	
	slickInit = function(){
		
		
		$('.c-news-slider').slick({
			slidesToShow: 3,
			slidesToScroll: 3,
			dots: true,
			autoplay: true,
			autoplaySpeed: 5000,
			speed: 700,
			responsive: [
				{
					breakpoint: 900,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					}
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 2
					}
				}
			]
		});
		
	};
	
})(jQuery);
	
	
var slickInit$1 = slickInit;

(function($){
		
	$(document).ready(function(){
		
		documentInit$1();
		smoothScrollInit$1();
		scrollNavInit$1();
		modalInit$1();
		mobileNavInit$1();
		
		submissionForminit$1();
		slickInit$1();
		
	});
		
})(jQuery);

}());
